import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import customFetchBase from './customFetchBase';

const baseUrl = `${import.meta.env.VITE_APP_API}`;

export const apiSlice = createApi({
  reducerPath: 'api',
  tagTypes: [
    'Shops',
    'Regions',
    'Agencies',
    'Records',
    'Pictures',
    'States',
    'Bulks',
    'Users',
    'Notifications',
    'Forms',
    'Clients',
    'Vacancies',
    'Candidates',
    'Dashboard'
  ],

  endpoints: (builder) => ({}),
  baseQuery: customFetchBase
});
